import { render, staticRenderFns } from "./AnosafraForm.vue?vue&type=template&id=492e931a"
import script from "./AnosafraForm.vue?vue&type=script&lang=js"
export * from "./AnosafraForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports